import { FC } from 'react';
import classNames from 'classnames';

import { ImagePackSetVariation } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';
import { H3 } from '@rikstv/shared-components';

import { Breakpoints } from '../../grid/breakpoints';
import { getLinkTo } from '../swimlane.utils';

import { ItemWrapper } from './ItemWrapper';
import { StandardItem, StandardItemProps } from './StandardItem';

import styles from './MenuTextItem.module.css';

export const MenuSwimlaneItem: FC<StandardItemProps> = props => {
  if (
    props.swimlaneStyle === 'MenuThumbnail' ||
    props.swimlaneStyle === 'MenuCircle' ||
    props.swimlaneStyle === 'MenuLogo'
  ) {
    return <StandardItem {...props} centeredTitle />;
  }

  if (props.swimlaneStyle === 'MenuText') {
    return (
      <div className={classNames(styles.wrapper, 'with-keyboard-focus-within')}>
        <ItemWrapper className={styles.menuTextItem} linkTo={getLinkTo(props.asset)} onClick={props.onClick}>
          <H3 className={styles.menuItemTitle} lookLike={'title-4'}>
            {props.asset.title}
          </H3>
        </ItemWrapper>
      </div>
    );
  }
};

//used for menuCircle and menuLogo
export const menuIconsImageConfig: ImagePackSetVariation[] = [
  { width: 150, breakpoint: Breakpoints.MD },
  { width: 200, breakpoint: Breakpoints.DEFAULT },
];

export const menuThumbnailItemImageConfig: ImagePackSetVariation[] = [{ width: 300, breakpoint: Breakpoints.DEFAULT }];
